import _ from 'lodash';
import moment from 'moment';
import BaseAccountController from '../../lib/controllers/BaseAccountController';

export interface IMonthlyClubVisits {
	month: string;
	clubVisits: MyAccountApi.IClubVisit[];
	daysVisited: number;
	totalVisits: number;
}

export interface IFilterOption {
	id: number;
	label: string;
	dateRange: IDateRange;
}

export interface IDateRange {
	start_date: string;
	end_date: string;
}

export default class ClubVisitsController extends BaseAccountController {
	public static $inject: string[] = ['$window', '$scope', 'UserResource', 'ClubVisitResource', 'MembershipResource'];

	public user: MyAccountApi.IUser;
	public numClubVisitsThisMonth: number;
	public allClubVisits: MyAccountApi.IClubVisit[];
	public filterOptions: IFilterOption[] = [];
	public selectedFilter: object;
	public clubVisitsByMonth: IMonthlyClubVisits[] = [];
	public membershipDetails: MyAccountApi.IMembership;

	private readonly User: MyAccountApi.IUserResource;
	private readonly ClubVisit: MyAccountApi.IClubVisitResource;
	private readonly Membership: MyAccountApi.IMembershipResource;
	private readonly $window: ng.IWindowService;

	constructor($window: ng.IWindowService, $scope: ng.IScope, User: MyAccountApi.IUserResource, ClubVisit: MyAccountApi.IClubVisitResource,
			Membership: MyAccountApi.IMembershipResource) {
		super($scope);

		this.$window = $window;
		this.User = User;
		this.ClubVisit = ClubVisit;
		this.Membership = Membership;

		this.loadFilterData();
	}

	public filterChanged(value: IFilterOption): void {
		this.ClubVisit.query({
			start_date: value.dateRange.start_date,
			end_date: value.dateRange.end_date
		}, this.updateClubVisits.bind(this));
	}

	public print(): void {
		this.$window.print();
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		// load My Account user details
		this.user = this.User.get();
		// load club visits
		this.ClubVisit.query({month_offset: 0}, this.updateClubVisits.bind(this));
		// membership details
		this.membershipDetails = this.Membership.get();
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private loadFilterData(): void {
		const today = moment();
		const lastYear = {
			start_date: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
			end_date: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
		};

		const thisYear = {
			start_date: moment().startOf('year').format('YYYY-MM-DD'),
			end_date: today.format('YYYY-MM-DD')
		};

		for (let i = 0; i <= moment().month(); i++) {
			const month = moment().subtract(i, 'month');
			const startDate = month.startOf('month').format('YYYY-MM-DD');
			const endOfMonth = moment().month() === month.month() ? today : month.endOf('month');
			const endDate = endOfMonth.format('YYYY-MM-DD');

			this.filterOptions.push({
				id: i,
				label: month.format('MMMM'),
				dateRange: {
					start_date: startDate,
					end_date: endDate
				}
			});
		}

		this.filterOptions.push({
			id: this.filterOptions.length,
			label: 'Year to Date',
			dateRange: thisYear
		});

		this.filterOptions.push({
			id: this.filterOptions.length,
			label: 'Last Year',
			dateRange: lastYear
		});

		this.selectedFilter = this.filterOptions[0];
	}

	private updateClubVisits(clubVisits: MyAccountApi.IClubVisit[]): void {
		this.allClubVisits = clubVisits;
		const monthGroups = _.groupBy<MyAccountApi.IClubVisit>(clubVisits, (visit) => {
			return moment(visit.usageDateTime).format('MMMM YYYY');
		});

		this.clubVisitsByMonth = _.map(monthGroups,
				(group: MyAccountApi.IClubVisit[], key: string) => {
			return {
				month: key,
				daysVisited: _.uniqBy(group, (visit: MyAccountApi.IClubVisit) => {
					return visit.usageDate;
				}).length,
				totalVisits: group.length,
				clubVisits: group
			};
		});
	}
}
